export default __webpack_public_path__ + "static/media/223.c4380865.png";